export enum ExceptionTypes {
  Sku = "SKU",
  Store = "STORE",
}

export const exceptionTypeOptions = [
  { value: ExceptionTypes.Sku, label: "SKU" },
  { value: ExceptionTypes.Store, label: "Store" },
];
